// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__n3fdK"};